{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.894825, 52.372193]
      },
      "properties": {
        "sensor": "CMSA-GAWW-21",
        "naam": "Damstraat",
        "perDag": 68751,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.898038, 52.377144]
      },
      "properties": {
        "sensor": "GACM-04",
        "naam": "Damrak 1-5",
        "perDag": 62619,
        "dagen": 356,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.89284, 52.37238]
      },
      "properties": {
        "sensor": "CMSA-GAKH-01",
        "naam": "Kalverstraat t.h.v. 1",
        "perDag": 59463,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.898903, 52.373805]
      },
      "properties": {
        "sensor": "CMSA-GAWW-12",
        "naam": "Oudekennissteeg",
        "perDag": 50473,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.896803, 52.375633]
      },
      "properties": {
        "sensor": "CMSA-GAWW-20",
        "naam": "Oudebrugsteeg",
        "perDag": 47016,
        "dagen": 363,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.899834, 52.37461]
      },
      "properties": {
        "sensor": "CMSA-GAWW-11",
        "naam": "Korte Niezel",
        "perDag": 44079,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.892728, 52.373783]
      },
      "properties": {
        "sensor": "GACM-02",
        "naam": "Nieuwendijk t.h.v.218",
        "perDag": 42913,
        "dagen": 365,
        "van": "2023-01-09",
        "tot": "2024-01-08",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.891708, 52.370498]
      },
      "properties": {
        "sensor": "GACM-01",
        "naam": "Kalverstraat Zuid t.h.v.73",
        "perDag": 40324,
        "dagen": 339,
        "van": "2023-01-09",
        "tot": "2024-01-08",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.898171, 52.372952]
      },
      "properties": {
        "sensor": "CMSA-GAWW-15",
        "naam": "Oudezijds Achterburgwal t.h.v. 86",
        "perDag": 36926,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.899577, 52.376258]
      },
      "properties": {
        "sensor": "CMSA-GAWW-24",
        "naam": "Nieuwebrugsteeg",
        "perDag": 36486,
        "dagen": 365,
        "van": "2022-10-27",
        "tot": "2023-10-26",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.899796, 52.373569]
      },
      "properties": {
        "sensor": "CMSA-GAWW-19",
        "naam": "Molensteeg",
        "perDag": 30267,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.898307, 52.372584]
      },
      "properties": {
        "sensor": "CMSA-GAWW-16",
        "naam": "Oudezijds Achterburgwal t.h.v. 91",
        "perDag": 29040,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.896558, 52.372738]
      },
      "properties": {
        "sensor": "CMSA-GAWW-17",
        "naam": "Oudezijds Voorburgwal t.h.v. 206",
        "perDag": 28488,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.898105, 52.370007]
      },
      "properties": {
        "sensor": "CMSA-GAWW-22",
        "naam": "Kloveniersburgwal",
        "perDag": 27178,
        "dagen": 289,
        "van": "2022-11-18",
        "tot": "2023-11-17",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.897385, 52.372517]
      },
      "properties": {
        "sensor": "CMSA-GAWW-13",
        "naam": "Stoofsteeg",
        "perDag": 26227,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.893044, 52.372971]
      },
      "properties": {
        "sensor": "GADM-01-total",
        "naam": "Dam",
        "perDag": 23859,
        "dagen": 365,
        "van": "2022-11-17",
        "tot": "2023-11-16",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.892342, 52.370573]
      },
      "properties": {
        "sensor": "GACM-03",
        "naam": "Rokin 66",
        "perDag": 23091,
        "dagen": 365,
        "van": "2023-01-09",
        "tot": "2024-01-08",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.898355, 52.373546]
      },
      "properties": {
        "sensor": "CMSA-GAWW-14",
        "naam": "Oudezijds Voorburgwal t.h.v. 91",
        "perDag": 15782,
        "dagen": 364,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.893444, 52.355555]
      },
      "properties": {
        "sensor": "GAAM-01-AlbertCuypstraat",
        "naam": "Albert Cuypstraat",
        "perDag": 13227,
        "dagen": 365,
        "van": "2020-10-01",
        "tot": "2021-09-30",
        "corona": true
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.899325, 52.372883]
      },
      "properties": {
        "sensor": "CMSA-GAWW-23",
        "naam": "Bloedstraat",
        "perDag": 10557,
        "dagen": 365,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.900769, 52.37434]
      },
      "properties": {
        "sensor": "GAWW-07",
        "naam": "Stormsteeg t.h.v. 3",
        "perDag": 7108,
        "dagen": 348,
        "van": "2020-04-08",
        "tot": "2021-04-07",
        "corona": true
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.897589, 52.372401]
      },
      "properties": {
        "sensor": "GAWW-05",
        "naam": "Oudezijds Achterburgwal t.h.v. 116",
        "perDag": 5055,
        "dagen": 354,
        "van": "2020-04-08",
        "tot": "2021-04-07",
        "corona": true
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.897962, 52.373247]
      },
      "properties": {
        "sensor": "GAWW-04",
        "naam": "Oudezijds Voorburgwal t.h.v. 107",
        "perDag": 3119,
        "dagen": 349,
        "van": "2020-04-08",
        "tot": "2021-04-07",
        "corona": true
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.940648, 52.313585]
      },
      "properties": {
        "sensor": "CMSA-GAABM-05",
        "naam": "Johan Cruijff Boulevard (ArenA)",
        "perDag": 3061,
        "dagen": 331,
        "van": "2023-03-30",
        "tot": "2024-03-28",
        "corona": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [4.821799, 52.379622]
      },
      "properties": {
        "sensor": "GACTO-PL4-01",
        "naam": "Plein 40-45 Noord",
        "perDag": 688,
        "dagen": 89,
        "van": "2021-08-13",
        "tot": "2021-11-16",
        "corona": true
      }
    }
  ]
}
